import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTranslatePdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#35C2FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.685 15.704h5.38m-5.38 0-1.435 2.963m1.435-2.963 2.149-4.438c.173-.358.26-.537.378-.593a.38.38 0 0 1 .326 0c.118.056.205.235.378.593l2.15 4.438m0 0 1.434 2.963M4.5 6.815H9m0 0h2.625M9 6.815V5.333m2.625 1.482H13.5m-1.875 0c-.372 2.19-1.236 4.175-2.5 5.84m1.375.826a7 7 0 0 1-1.376-.826m0 0c-1.014-.768-1.922-1.82-2.374-2.877m2.374 2.877a12.94 12.94 0 0 1-4.624 3.79"
    />
  </svg>
);
export default SvgTranslatePdf;
